import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import FullTable from "components/FullTable"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import clone from "clone"
import numeral from "numeral"
import settings from "settings"
import InventorySelloutLotTypeBuilder from "widgets/inventorySelloutLotTypeBuilder"
import helpers from "helpers/helpers"
import LotTypeHealth from "widgets/inventoryLotTypeHealth"
import InventorySelloutSectionLotTypeBuilder from "widgets/inventorySelloutSectionLotTypeBuilder"

class BuilderInventorySupply extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			remaining: 0,
			specs: [
				{
					Header: "Community",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Lot Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "type"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Block",
					accessor: "block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Square Feet",
					accessor: "sqft",
					filterMethod: (f, r) => helpers.tableText(f, r, "sqft"),
				},
				{
					Header: "Start Date",
					accessor: "start_date",
					Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
					filterMethod: (f, r) => helpers.tableText(f, r, "start_date"),
				},
				{
					Header: "Complete Date",
					accessor: "complete_date",
					Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
					filterMethod: (f, r) => helpers.tableText(f, r, "complete_date"),
				},
				{
					Header: "Days On Market",
					accessor: "daysOnMarket",
					filterMethod: (f, r) => helpers.tableText(f, r, "daysOnMarket"),
				},
				{
					Header: "On Website",
					accessor: "on_website",
					filterMethod: (f, r) => helpers.tableText(f, r, "on_website"),
				},
				{
					Header: "Price",
					accessor: "price",
					filterMethod: (f, r) => helpers.tableText(f, r, "price"),
					Cell: (v) => {
						return v.value ? numeral(v.value).format("$0,0") : ""
					},
				},
			],
			builderOwnedVDL: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Block",
					accessor: "block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
			],
		}
	}

	componentDidMount() {
		this.calculateRemaining()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.payload.exec.lots !== this.props.payload.exec.lots) {
			this.calculateRemaining()
		}
	}

	calculateRemaining() {
		let remaining = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (!v.sale_id) {
				remaining++
			}
		})
		this.setState({ remaining })
	}

	filterChange = (e) => {
		let state = clone(this.state)
		state.filters[e.target.value] = !state.filters[e.target.value]
		this.setState(state)
	}

	toggleAll = (checked) => {
		let filters = clone(this.state.filters)
		_.forEach(filters, (v, k) => {
			filters[k] = checked
		})
		this.setState({ filters: filters })
	}

	currentSpecInventory() {
		let ret = []
		try {
			_.forEach(this.props.payload.exec.lots, (v) => {
				if (v.lot_status == "Closed" || v.lot_status == "Contract" || !v.start_date || v.model) return
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				let sec = _.find(this.props.payload.public.sections, { id: v.section_id })
				let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				let property = _.find(this.props.payload.public.properties, { id: v.property })
				let on_website = v.start_date > 0 && !v.sale_date && v.marketing_price ? "Yes" : "No"
				if (settings.requireInFeed) {
					//if (v.in_feed === 0 && v.in_feed_manual === 0) {
					if (v.in_feed === 0 && !v.in_feed_manual) {
						on_website = "No"
					}
				}
				let daysOnMarket
				// days between the complet_date and now
				if (v.complete_date) {
					daysOnMarket = moment().diff(moment.unix(v.complete_date), "days")
				}
				ret.push({
					builder: builder ? builder.name : "",
					address: v.address,
					section: sec.name,
					lot: v.lot,
					block: v.block,
					type: type.name,
					sqft: v.sqft,
					property: property.name,
					price: v.marketing_price,
					start_date: v.start_date,
					daysOnMarket,
					complete_date: v.complete_date,
					on_website,
				})
			})
		} catch (e) {
			console.log(e)
		}
		return ret
	}

	builderOwnedVDL = () => {
		let ret = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			try {
				if (v.takedown_date && v.builder && !v.start_date && !v.complete_date && !v.sale_id && !v.model) {
					let builder = _.find(this.props.payload.public.builders, { id: v.builder })
					let section = _.find(this.props.payload.public.sections, { id: v.section_id })
					ret.push({
						builder: builder ? builder.name : null,
						lot: v.lot,
						block: v.block,
						section: section ? section.name : null,
						address: v.address,
					})
				}
			} catch (e) {
				console.log(e)
			}
		})
		return ret
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.props.activeProperties.length > 1) {
			return <h1 className="chooseError">Please choose only one property.</h1>
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Builder Inventory Supply" showDate={false} cutPadding={true} />
						<div className="content">
							<p className="mb-5 text-sm">
								Total Combined Remaining Inventory: {this.state.remaining}. These tables{" "}
								<span className="font-bold">include</span> models in sales opportunities. Sales opportunities is all unsold to buyer lots, irregardless of takedown date.  Only requirement is builder assignment.
							</p>
							<InventorySelloutLotTypeBuilder />
							<LotTypeHealth />
							<InventorySelloutSectionLotTypeBuilder />
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h3>Current Spec Inventory</h3>
							<FullTable
								data={this.currentSpecInventory()}
								columns={this.state.specs}
								name="builderInventorySupply__specs"
								title="Current Spec Inventory"
								unset={["edit"]}
								pageSize={20}
							/>
							<h3>Builder Owned VDL</h3>
							<FullTable
								data={this.builderOwnedVDL()}
								columns={this.state.builderOwnedVDL}
								name="builderInventorySupply__builderOwnedVDL"
								title="Builder Owned VDL"
								pageSize={20}
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuilderInventorySupply)
